module.exports = __webpack_public_path__ + "img/backstage.9794c517.png";